export default angular
  .module('gm.wealth.common')
  .filter('gmwSlashToNewline', gmwSlashToNewline)
  .name;

function gmwSlashToNewline() {
  'ngInject';

  return (input) => {
    if (!input) {
      return input;
    }
    return input.replace(/\\/g, '<br>');
  };
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/slash-to-newline.js